import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-51f1b4fe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex" }
const _hoisted_2 = {
  class: "d-flex justify-content-between align-items-center",
  style: {"width":"100%"}
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_4 = {
  key: 0,
  class: "type-details"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "gray" }, [
  /*#__PURE__*/_createTextVNode("Pełne oznaczenie wersji:"),
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_6 = { class: "bold" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "kW", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "ccm", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Rodzaj konstrukcji", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Paliwo", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Silnik", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_arrow_left = _resolveComponent("arrow-left")!
  const _component_arrow_down = _resolveComponent("arrow-down")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("span", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeCar(_ctx.car))),
          class: _normalizeClass(["select-car-name", {
            'list-group-selected': _ctx.car.typeId === _ctx.getSelectedCar?.typeId,
          }])
        }, _toDisplayString(_ctx.car.makeName) + " " + _toDisplayString(_ctx.car.rangeName), 3)
      ]),
      _createElementVNode("div", {
        class: "expand-icon",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.expandDetailsTable && _ctx.expandDetailsTable(...args)))
      }, [
        (_ctx.expandableDetails)
          ? (_openBlock(), _createBlock(_component_arrow_left, { key: 0 }))
          : (_openBlock(), _createBlock(_component_arrow_down, { key: 1 }))
      ])
    ]),
    (_ctx.expandableDetails)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("span", _hoisted_6, [
            _createTextVNode(_toDisplayString(_ctx.car.makeName) + " " + _toDisplayString(_ctx.car.rangeName), 1),
            _hoisted_7,
            _createTextVNode(_toDisplayString(_ctx.car.typeName) + " (" + _toDisplayString(_ctx.car.fuel) + ")", 1),
            _hoisted_8,
            _createTextVNode(_toDisplayString(_ctx.yearBrackets(_ctx.car.yearFrom, _ctx.car.yearTo)), 1)
          ]),
          _createElementVNode("table", null, [
            _createElementVNode("tr", null, [
              _hoisted_9,
              _createElementVNode("td", null, _toDisplayString(_ctx.car.kw), 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_10,
              _createElementVNode("td", null, _toDisplayString(_ctx.car.ccm), 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_11,
              _createElementVNode("td", null, _toDisplayString(_ctx.car.construction), 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_12,
              _createElementVNode("td", null, _toDisplayString(_ctx.car.fuel), 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_13,
              _createElementVNode("td", null, _toDisplayString(_ctx.car.engine), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}